import React from "react";

const defaultusageWaterData = [
  // Withdrawal Section
  {
    section: "Water withdrawal by source (in kilolitres)",
    label: "(i) Surface water",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kilolitres)",
    label: "(ii) Ground water",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kilolitres)",
    label: "(iii) Third party water",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kilolitres)",
    label: "(iv) Seawater / desalinated water",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kilolitres)",
    label: "(v) Others",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kilolitres)",
    label: "Total volume of water withdrawal (i + ii + iii + iv + v)",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kilolitres)",
    label: "Total volume of water consumption (in kilolitres)",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kilolitres)",
    label: "Water intensity per rupee of turnover (Water consumed/turnover)",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kilolitres)",
    label:
      "Water intensity (optional) the relevant metric may be selected by the entity",
    current: "",
    previous: "",
  },

  // Discharge Section
  {
    section: "(i) Into Surface water",
    label: "• No treatment",
    current: "",
    previous: "",
  },
  {
    section: "(i) Into Surface water",
    label: "• With treatment – please specify level of treatment",
    current: "",
    previous: "",
  },
  {
    section: "(ii) Into Groundwater",
    label: "• No treatment",
    current: "",
    previous: "",
  },
  {
    section: "(ii) Into Groundwater",
    label: "• With treatment – please specify level of treatment",
    current: "",
    previous: "",
  },
  {
    section: "(iii) Into Seawater",
    label: "• No treatment",
    current: "",
    previous: "",
  },
  {
    section: "(iii) Into Seawater",
    label: "• With treatment – please specify level of treatment",
    current: "",
    previous: "",
  },
  {
    section: "(iv) Sent to third-parties",
    label: "• No treatment",
    current: "",
    previous: "",
  },
  {
    section: "(iv) Sent to third-parties",
    label: "• With treatment – please specify level of treatment",
    current: "",
    previous: "",
  },
  {
    section: "(v) Others",
    label: "• No treatment",
    current: "",
    previous: "",
  },
  {
    section: "(v) Others",
    label: "• With treatment – please specify level of treatment",
    current: "",
    previous: "",
  },
  {
    section: "(v) Others",
    label: "Total water discharged (in kilolitres)",
    current: "",
    previous: "",
  },
];

const WaterUsageAndDischargeTable = ({
  waterusagedata = [],
  setWaterUsageData,
}) => {
  const flatData =
    waterusagedata.length > 0 ? waterusagedata : defaultusageWaterData;

  const handleChange = (index, field, value) => {
    const updated = [...flatData];
    updated[index][field] = value;
    setWaterUsageData(updated);
  };

  const groupedData = flatData.reduce((acc, row, index) => {
    if (!acc[row.section]) acc[row.section] = [];
    acc[row.section].push({ ...row, index });
    return acc;
  }, {});

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#d3c9ce", fontWeight: "bold" }}>
            <th style={parameterHeaderStyle}>Parameter</th>
            <th style={headerStyle}>
              FY _____ <br /> Current Financial Year
            </th>
            <th style={headerStyle}>
              FY _____ <br /> Previous Financial Year
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(groupedData).map(([section, rows], index) => (
            <React.Fragment key={section}>
              <tr>
                <td colSpan={3} style={sectionHeaderStyle}>
                  {section}
                </td>
              </tr>
              {rows.map((row) => (
                <tr key={row.label}>
                  <td style={labelCellStyle}>{row.label}</td>
                  <td style={cellStyle}>
                    <input
                      type="text"
                      placeholder="Current FY"
                      value={row.current}
                      onChange={(e) =>
                        handleChange(row.index, "current", e.target.value)
                      }
                      style={inputStyle}
                    />
                  </td>
                  <td style={cellStyle}>
                    <input
                      type="text"
                      placeholder="Previous FY"
                      value={row.previous}
                      onChange={(e) =>
                        handleChange(row.index, "previous", e.target.value)
                      }
                      style={inputStyle}
                    />
                  </td>
                </tr>
              ))}
              {index === 0 && (
                <tr>
                  <td colSpan={3} style={sectionHeaderStyle}>
                    {
                      "Water discharge by destination and level of treatment(in kiloliters)"
                    }
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "15px",
  border: "1px solid #000",
  textAlign: "center",
  backgroundColor: "#d3c9ce",
};

const parameterHeaderStyle = {
  ...headerStyle,
  width: "35%",
};

const sectionHeaderStyle = {
  padding: "10px",
  backgroundColor: "#d3c9ce",
  fontWeight: "bold",
  border: "1px solid #000",
  textAlign: "center",
};

const labelCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  backgroundColor: "#d3c9ce",
  textAlign: "left",
  fontWeight: "bold",
  lineHeight: "1.5",
};

const cellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputStyle = {
  width: "90%",
  padding: "8px",
  fontSize: "14px",
  border: "1px solid grey",
  borderRadius: "4px",
};

export default WaterUsageAndDischargeTable;
